import { APICallV3Post } from 'reactApp/api/APICall';

type SubscriptionBuyMidasResponse = { pw: string };

export class SubscriptionBuyMidasAPICall extends APICallV3Post<SubscriptionBuyMidasResponse> {
    _method = 'billing/subscription/buy2';
}
